import React, { Component, Suspense } from 'react';
import { withRouter, matchPath } from 'react-router-dom';
import { Nav, Navbar, NavItem, NavLink } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import logo from '../../assets/img/brand/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Icons from '@fortawesome/free-solid-svg-icons';

class WorksheetNavigation extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { sections: [] }
        this.renderNav = this.renderNav.bind(this);
        this.goToPage = this.goToPage.bind(this);
    }

    componentDidMount() {
        this.setState({ sections: this.props.sections });
    }

    goToPage(section, page) {
        this.props.goToPage(page);
        this.props.scrollToSection(section);
    }

    renderNav() {
        let pages = this.props.pages;
        if (this.props.pages.length > 0) {
            const pages = this.props.pages.map((page, pidx) => {
                return (
                    <div className={this.props.currentPage === pidx ? "worksheet-nav-page worksheet-nav-page-selected" : "worksheet-nav-page"}>
                        {
                            page.map((section, sidx) => {
                                return (
                                    <div className="worksheet-nav-item givemethefinger" onClick={() => this.goToPage(sidx, pidx)}>
                                        {section.reviewable ? section.controlGroup + ": " + section.name : section.name}
                                    </div>)
                            })
                        }
                    </div>
                );
            });
            return pages;
        } else {
            return null;
        }
        //const items = this.props.sections.map((section, idx) => {
        //    return (
        //        <div className="worksheet-nav-item">
        //            <div>
        //                {section.controlGroup}: {section.name}
        //            </div>
        //        </div>
        //    );
        //});
        //return items;
    }

    render() {

        return (
            <div className="bg-medium" style={{ height: "100%", width: "320px", left: "0", position: "fixed", float: "left" }} id="sideNavBar" name="sideNavBar">

                <div className="sidebar-header bg-light">

                    <LinkContainer to='/home'>
                        <a className="sidebar-brand float-left navbar-brand" href="#">
                            <img
                                src={logo}
                                width="137"
                                height="40"
                                className="d-inline-block align-top"
                                alt="HCF Logo"
                            />
                        </a>
                    </LinkContainer>
                </div>
                <div className="worksheet-nav" id="worksheetContainer">
                    {this.renderNav()}
                </div>
            </div>
        );
    }
}

export default WorksheetNavigation;